// Hocs
import asyncRoute from '../AsyncRoute'

import { ACCOUNT_ROUTE_URLS } from '../constants'
import getRequestName from '../components/getRequestName'

// Exports
export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-accounts').accountContainer
      const requestInfoMaskHoc = require('fc-requests').requestInfoMaskHoc
      const requestInfo$ = require('fc-requests').getFilteredRequestsInProgress$(ACCOUNT_ROUTE_URLS)

      resolve(requestInfoMaskHoc({
        requestInfo$,
        getRequestName,
      })(View))

    /* Webpack named bundle   */
    }, 'accounts')
  })
}

export default asyncRoute({getComponent, reducers: []})
